import { render } from "./AutomationsList.vue?vue&type=template&id=5889b279&ts=true"
import script from "./AutomationsList.vue?vue&type=script&lang=ts"
export * from "./AutomationsList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/paulbele/Code/repositories/maatoo-app-master/package/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__